export default __webpack_public_path__ + "static/media/webpack-dependency-tree.7887ae0e.png";